import Vue from 'vue'

import afterColumn from './column-hints-after-column'
Vue.component(afterColumn.name, afterColumn)

export default {
    slots() {
        return [
            {
                slot: "after-column",
                component: afterColumn.name,
                condition(attrs) {
                    return this.displayHints && !!attrs.hint
                }
            }
        ]
    },
    mixins() {
        return {
            props: {
                displayHints: {
                    type: Boolean,
                    default: true
                }
            }
        }
    }
}
